import React from 'react';
export function DisclaimerSection() {
  return <section className="py-12 bg-gray-900 px-4" data-id="element-90">
      <div className="max-w-4xl mx-auto text-center" data-id="element-91">
        <p className="text-xs md:text-sm text-gray-400 leading-relaxed" data-id="element-92">
          DESCARGO DE RESPONSABILIDAD: Este eBook y su contenido son
          estrictamente para fines educativos e informativos. No pretenden
          diagnosticar, tratar, curar ni prevenir ninguna enfermedad. La
          información proporcionada no reemplaza el consejo médico profesional,
          el diagnóstico o el tratamiento. Los resultados pueden variar según
          cada persona y su compromiso con el método. Siempre debes consultar a
          un médico o profesional de la salud calificado antes de hacer cambios
          significativos en tu dieta, estilo de vida o si tienes alguna
          condición médica preexistente, especialmente diabetes o prediabetes.
        </p>
        <p className="text-xs text-gray-500 mt-4" data-id="element-93">
          © {new Date().getFullYear()} El Código del Azúcar en Sangre. Todos
          los derechos reservados.
        </p>
      </div>
    </section>;
}